import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ViewModeState {
  activeView: {};
}

const initialState: ViewModeState = {
  activeView: {},
};

const viewModeSlice = createSlice({
  name: "viewMode",
  initialState,
  reducers: {
    setViewMode: (state: ViewModeState, action: PayloadAction<{}>) => {
      state.activeView = action.payload;
    },
  },
});

export const { setViewMode } = viewModeSlice.actions;
export default viewModeSlice.reducer;
